export default {
  dialog: {
    title1: "Approval Record",
    title2: "Help",
    title3: "Settlement Statement for Outsourcing Costs of Local Job Services",
    title4: "Approval Details of Airfare Expense Splitting Document",
    title5: "Modify foreign affairs relations",
    title6: "Block List",
    title7: "Unit",
    title8: "Stakeholder",
    title9: "leave days",
    title10: "Adjustment of vacation days",
    title11: "Flight history records",
    title12: "Attachment upload",
    title13: "Please select the visa subject first",
    title14: "Transfer for approval",
    title15: "Upload passport",
    title16: "Upload temporary residence permit",
    title17: "Change Currency",
    title18: "Cancel warning",
    title19: "Batch setting of superiors",
    title20: "Modify flight ticket",
    title21: "Modification Fee",
    title22: "Reward and punishment management",
    title23: "Assessment and Contract Renewal Management",
    title24: "Do you want to add to the existing approval form",
    title25: "Cost update",
  },

  //长名词
  longNoun: {
    backToPreviousPage: "Back To Previous Page",
    title1: "Welcome to the Saudi Integrated Management System",
    title2: "Hello! Start a day full of energy",
    title3: "Login at",
    title4: "No data available",
    title5: "Loading ...",
    title6: "Review",
    title7: "Audit Record",
    title8: "Reward and Punishment Management",
    title9: "Assessment management of local job service outsourcing units",
    title10: "No attachment",
    title11: "Institutional Qualification",
    title12: "Ticket agency resource library management details",
    title13: "Details of employee labor insurance records",
    title14: "Character List",
    title15: "Message Type",
    title16: "Select All",
    title17: "Cancel all",
    title18: "Menu Permissions",
    title19: "Selection Strategy",
    title20: "Save Strategy",
    title21: "Menu configuration instructions",
    title22:
      "1. If the Vue page is generated using a code generator, the URL should be the path property of the table name corresponding to src ->router ->viewGrid.exe in the Vue project",
    title23:
      "2. If you only need to create a first level menu or an empty menu URL, do not fill in the 'View/Table Name' field Or/",
    title24: "Modify the labor insurance application cycle",
    title25: "Foreign Affairs Handover Record",
    title26: "Summary of Foreign Affairs Payment Details and Cost Segmentation",
    title27: "Summary of Foreign Affairs Payment Details",
    title28: "Government Platform Details",
    title29: "HR Weekly Report",
    title30: "Monthly credit details of local job service fees",
    title31: "Outsourcing Unit Archive Management Form Page",
    title32: "Personnel File",
    title33: "Personnel backup files",
    title34: "Summary of Expense Details and Payment Order Details",
    title35: "Summary of Expense Details and Split Sheet Details",
    title36: "Certificate of Employment Separation",
    title37: "Personnel evacuation application",
    title38: "My application",
    title39: "Suggestions for system optimization",
    title40: "Income Certificate",
    title41: "IQAMA",
    title42: "leave",
    title43: "work overtime",
    title44: "passport",
    title45: "payslip",
    title46: "Employee position changes",
    title47: "Proof of Work",
    title48: "System Notification",
    title49: "Individual income tax payment",
    title50: "Ticket change",
    title51: "Ticket requisition",
    title52: "Visa",
    title53: "Change password",
    ReleaseNews: "Release News",
    SoFar: "So Far",
  },

  //筛选和表格公用
  filterTable: {
    processName: "Process Name",
    approvalBusiness: "Approval Business",
    businessTable: "Business Table",
    businessTableName: "Business Table Name",
    approvalStatus: "Approval Status",
    creator: "Creator",
    creationTime: "Creation Time",
    name: "Name",
    name1: "Chinese Name",
    EPIProjectNumber: "EPI Project Number",
    projectDepartmentNumber: "Number",
    projectName: "Project Name",
    projectName1: "Project Name",
    ProjectNumber: "Project Number",
    status: "Status",
    code: "Code",
    encoding: "Encoding",
    enableOrNot: "Enable Or Not",
    jobNature: "Job Nature",
    jobCategory: "Job Category",
    jobClassification: "Job Classification",
    jobSubcategory: "Job Subcategory",
    accountingEntity: "Accounting Entity",
    employeeCode: "Employee Code",
    employeeCode1: "Employee Code",
    employeeID: "Employee ID",
    RegisterID: "Register ID",
    educationLevel: "Education Level",
    degree: "Degree",
    major: "Major",
    graduatedFrom: "Graduated From",
    IDNumber: "ID Number",
    EmployeeName: "Employee Name",
    PassportNumber: "Passport Number",
    VisaType: "Visa Type",
    RewardAndPenaltyRecord: "Reward And Penalty Record",
    RewardAndPunishmentDate: "Reward And Punishment Date",
    InformationType: "Information Type",
    IQAMAID: "IQAMAID",
    subProjectName: "Sub Project Name",
    subProjectName1: "Sub Project Name",
    WorkingUnit: "Working Unit",
    department: "Department",
    subDepartment: "Sub Department",
    departmentNumber: "Department Number",
    nationality: "Nationality",
    LocalEmployer: "Local Employer",
    position: "Position",
    position1: "Position",
    ProfessionalExpertise: "Professional Expertise",
    dateOfTransfer: "Date Of Transfer",
    ApplicationDate: "Application Date",
    employmentForm: "Employment Form",
    EstimatedArrivalDate: "Estimated Arrival Date",
    ProjectA: "Project A",
    ProjectB: "Project B",
    UnitA: "Unit A",
    UnitB: "Unit B",
    ITMSANo: "ITMSA No",
    DurationOfSupply: "Duration Of Supply",
    InvoiceCode: "Invoice Code",
    CostCenterCode: "CostCenter Code",
    FeePeriod: "Fee Period",
    TOP: "TOP",
    TOD: "TOD",
    TIP: "TIP",
    TID: "TID",
    ForeignAffairsRelations: "Foreign Affairs Relations",
    EvacuationDate: "Evacuation Date",
    CR: "CR",
    DispatchCategory: "Dispatch Category",
    RecommendedBy: "Recommended By",
    whetherToVerify: "Whether To Verify",
    FirstParty: "First Party",
    EffectiveDateOfContract: "Effective Date Of Contract",
    Remark: "Remark",
    ToSecondParty: "To Second Party",
    IsItBeyondTheGuidancePrice: "Is It Beyond The Guidance Price",
    abbreviatedName: "Abbreviated Name",
    WhetherToIncludeApproval: "Whether To Include Approval",
    AgreeOrNot: "Agree Or Not",
    postingDate: "Posting Date",
    organizationalDepartment: "Organizational Department",
    TrainingCategory: "Training Category",
    TrainingClassName: "Training Class Name",
    PlannedDate: "Planned Date",
    TrainingTime: "Training Time",
    EmployeeName: "Employee Name",
    SubmissionDate: "Submission Date",
    CurrentLocation: "Current Location",
    TheoreticalNextVacationTime: "Theoretical Next Vacation Time",
    TheLatestReturnToTheSandTime: "The Latest Return To The Sand Time",
    LeaveType: "Leave Type",
    ReleaseDate: "Release Date",
    ContractTerminationDate: "Contract Termination Date",
    usageTime: "Usage Time",
    planType: "Plan Type",
    ApprovalAndConsentDate: "Approval And Consent Date",
    IsItUrgent: "Is It Urgent",
    WhetherToPay: "Whether To Pay",
    IsItCompleted: "Is It Completed",
    TemporaryResidencePermitNumberCustomsEntryNumber:
      "Temporary Residence Permit Number / Customs Entry Number",
    HighlightOrNot: "Highlight Or Not",
    TemporaryResidencePermitValidityPeriod: "IQAMA Valid Date",
    validityPeriodOfTheApprovalDocument:
      "validity Period Of The Approval Document",
    VisaCategory: "Visa Category",
    MaterialCollectionStatus: "Material Collection Status",
    VisaProcessingStatus: "Visa Processing Status",
    VisaValidity: "Visa Validity",
    VisaValidityStartDate: "Visa Validity Start Date",
    WhetherToUploadTheVisa: "Whether To Upload The Visa",
    IsItAssociatedWithAFlightTicket: "Is It Associated With A Flight Ticket",
    DoesTheVisaDurationCoverTheFlightDuration:
      "Does The Visa Duration Cover The Flight Duration",
    HasTheVisaBeenProcessed: "Has The Visa Been Processed",
    ValidityPeriodOfApprovalDocumentForOverseasMission:
      "Validity Period Of Approval Document For Overseas Mission",
    classification: "Classification",
    parentsMedicalInsuranceLevel: "parent's Medical Insurance Level",
    borderNumber: "Border Number",
    medicalInsuranceLevel: "Medical Insurance Level",
    medicalInsuranceStatus: "Medical Insurance Status",
    JobLevel: "Job Level",
    PassportValidity: "Passport Validity",
    PassportType: "Passport Type",
    OldPassport: "Old Passport",
    NewPassport: "New Passport",
    DriversLicenseValidityPeriod: "Driver's License Validity Period",
    LicenseNumber: "License Number",
    LicenseIssueDate: "License Issue Date",
    ChargedItems: "Charged Items",
    ProjectContent: "Project Content",
    Period: "Period",
    TaskNumber: "Task Number",
    WhetherToSummarize: "Whether To Summarize",
    IsTheFeeConfirmed: "Is The Fee Confirmed",
    BusinessCategory: "Business Category",
    StatisticalDate: "Statistical Date",
    TicketAgencyName: "Ticket Agency Name",
    MainAgencyAirlines: "Main Agency Airlines",
    CRValidityPeriod: "CR Validity Period",
    AbbreviationOfTicketingAgent: "Abbreviation Of Ticketing Agent",
    oneWayRoundTrip: "one-way/round-trip",
    routeCategory: "Route Category",
    DepartureDate: "Departure Date",
    ArrivalDate: "Arrival Date",
    ChangeStatus: "Change Status",
    VisaExpirationDate: "Visa Expiration Date",
    DateOfDeparture: "Date Of Departure",
    pickUpDate: "Pick Up Date",
    ticketAgency: "Ticket Agency",
    DateOfIssue: "Date Of Issue",
    WhetherToCreateAnApprovalForm: "Whether To Create An Approval Form",
    costCenter: "Cost Center",
    DepartureCountryRegion: "Departure Country / Region",
    departureCity: "Departure City",
    ArrivalCountryRegion: "Arrival Country / Region",
    ArriveInTheCity: "Arrive In The City",
    CountryRegionName: "Country / Region Name",
    IsItARouteCountryregion: "Is It A Route Country / Region",
    IsItAnAirlineCity: "Is It An Airline City",
    cityName: "City Name",
    CountryRegionOfOrigin: "Country / Region Of Origin",
    PeriodCategory: "Period Category",
    flightType: "Flight Type",
    DepartureDestinationCountry1: "Departure / Destination Country 1",
    DepartureDestinationCountry2: "Departure / Destination Country 2",
    TypeOfItinerary: "Type Of Itinerary",
    initialTrainingRetraining: "Initial Training / Retraining",
    CertificateValidityPeriod: "Certificate Validity Period",
    TypeOfInsurance: "Type Of Insurance",
    EndDateOfInsuranceLiability: "End Date Of Insurance Liability",
    DateOfLoss: "Date Of Loss",
    CategoryOfPhysicalExaminationItems:
      "Category Of Physical Examination Items",
    PhysicalExaminationValueCategory: "Physical Examination Value Category",
    PhysicalExaminationDate: "Physical Examination Date",
    SNEMECProjectSNEMEC: "SNEMEC / Project SNEMEC",
    UnitDepartment: "Unit / Department",
    AuxiliaryMaterialType: "Auxiliary Material Type",
    SafetyMaterialType: "Safety Material Type",
    OfficeMaterialType: "Office Material Type",
    RequestPeriod: "Request Period",
    BillDate: "Bill Date",
    ForeignAffairsBusinessType: "Foreign Affairs Business Type",
    displayForm: "Display Form",
    CostSummaryAndStatisticsPeriod: "Cost Summary And Statistics Period",
    NameofBank: "Name of Bank",
    IBANAccount: "IBAN Account",
    BankCode: "Bank Code",
    BankName: "Bank Name",
    ContactPerson: "Contact Person",
    PhoneNumber: "Phone Number",
    EmailAddress: "Email Address",
    annual: "Annual",
    quarter: "Quarter",
    liquidationDate: "Liquidation Date",
    roleName: "Role Name",
    title: "Title",
    EditableDuringReview: "Editable During Review",
    UpdateTime: "Update Time",
    Operation: "Operation",
    BusinessName: "Business Name",
    CurrentAuditNodeName: "Current Audit Node Name",
    No: "No",
    ChineseName: "Chinese Name",
    EnglishName: "English Name",
    Arabic: "Arabic",
    Abbreviation: "Abbreviation",
    ProjectManager: "Project Manager",
    ScheduledStartDate: "Scheduled Start Date",
    PlannedDuration: "Planned Duration",
    ProjectCategory1: "Project Category 1",
    ProjectCategory2: "Project Category 2",
    initialLevel: "Initial Level",
    assessmentResults: "Assessment Results",
    Finallevel: "Final level Redemption",
    stakeholderType: "Stakeholder Type",
    organizationalAttributes: "Organizational Attributes",
    registerAddress: "Register Address",
    SubcontractingSpecialty: "Subcontracting Specialty",
    legalPerson: "Legal Person",
    departmentAttribute: "Department Attribute",
    SaudiSpecialityName: "Saudi Speciality Name",
    SubjectClassificationName: "Subject Classification Name",
    nodeType: "Node Type",
    CompanyName: "Company Name",
    Gender: "Gender",
    ResidenceAddress: "Residence Address",
    EntryDate: "Entry Date",
    VisitEndDate: "Visit EndDate",
    AtLatestEndDate: "At Latest Visit EndDate",
    ExitDate: "Exit Date",
    AtLatestExitDate: "At Latest Exit Date",
    ReasonForDeparture: "Reason For Departure",
    updateType: "Update Type",
    updateDetails: "Update Details",
    reverseProject: "Reverse Project",
    reverseCompany: "Reverse Company",
    reversePosition: "Reverse Position",
    reverseJobClassification: "Reverse Job Classification",
    reverseStartDate: "Reverse Start Date",
    reverseEndDate: "Reverse End Date",

    requiredQuantity: "Required Quantity",
    resumeScreeningCount: "Resume ScreeningC ount",
    NumberOfInterviews: "Number Of Interviews",
    numberOfHires: "Number Of Hires",
    EstimatedArrivalDate: "Estimated Arrival Date",
    proposedUsageCycle: "Proposed Usage Cycle",
    EditStatus: "Edit Status",
    UsageCycle: "Usage Cycle",
    ITMSANo: "ITMSA No",
    CostCategoryName: "Cost Category Name",
    Amount: "Amount",
    Amount1: "Amount",
    CostDuration: "Cost Duration",
    InvoiceNumber: "Invoice Number",
    CompanyNameOfBeneficiary: "Company Name Of Beneficiary",
    flightRoute: "Flight Route",
    evacuationDate: "Evacuation Date",
    ManpowerSupplier: "Manpower Supplier",
    OfficeAddress: "Office Address",
    MainCategoryOfManpower: "Main Category Of Manpower",
    QuantityOfSponsoredEmployee: "Quantity Of Sponsored Employee",
    RecommendedReason: "Recommended Reason",
    RecommendedBy: "Recommended By",
    whetherToVerify: "Whether To Verify",
    DateOfTabulation: "Creation Date",
    positionNumber: "Position Number",
    WorkflowTableSN: "Workflow Table S/N",
    WorkflowTableSN1: "Workflow Table S/N",
    WorkflowTableSN2: "Workflow Table S/N",
    billingMonth: "Billing Month",
    ToSecondPartyAbbreviation: "To Second Party Abbreviation",
    PaymentMatters: "Payment Matters",
    AmountWithoutVAT: "Amount Without VAT",
    VATAmount: "VAT Amount",
    AmountWithVAT: "Amount With VAT",
    MDMSystemSN: "MDM System S/N",
    unitPrice: "Unit Price",
    manHours: "man-hours",
    CategoryAndDisciplineName: "Category And Discipline Name",
    PositionSystem: "Position System",
    PositionSubsystem: "Position Subsystem",
    Trainee: "Trainee",
    TrainingFormName: "Training Form Name",
    ClassHour: "Class Hour",
    NumberofTrainees: "Number of Trainees",
    CostEstimation: "Cost Estimation",
    CourseNumber: "Course Number",
    TrainerNumber: "Trainer Number",
    NameofTeacher: "Name of Teacher",
    TrainingTime: "Training Time",
    OrganizingUnit: "Organizing Unit",
    TrainingCost: "Training Cost",
    NumberofTrainees: "Number of Trainees",
    CurrentJobPositionName: "Current Job Position Name",
    NewJobPositionName: "New Job Position Name",
    LeaveStartTime: "Leave Start Time",
    LeaveEndTime: "Leave End Time",
    NumberOfLeaveDays: "Number Of Leave Days",
    VacationCycle: "Vacation Cycle",
    ActualLeaveStartTime: "Actual Leave Start Time",
    ActualLeaveEndTime: "Actual Leave End Time",
    ActualLeaveDays: "Actual Leave Days",
    TheoryLeaveDays: "Theory Leave Days",
    RemainingLeaveDays: "Remaining Leave Days",
    NextTheoryLeaveStartTime: "Next Theory Leave Start Time",
    NextTheoryLeaveEndTime: "Next Theory Leave End Time",
    TravelDays: "Travel Days",
    RequiredAttendanceDays: "Required Attendance Days",
    ActualAttendanceDays: "Actual Attendance Days",
    TotalNumberOfDaysInSaudiArabia: "Total Number Of Days In Saudi Arabia",
    NumberOfOvertimeDaysDuringHolidays:
      "Number Of Overtime Days During Holidays",
    OvertimeDaysDuringFestivals: "Overtime Days During Festivals",
    NmberOfPoints: "Nmber Of Points",
    NormalVacationDays: "Normal Vacation Days",
    NumberOfRegularHolidaysAndFestivals:
      "Number Of Regular Holidays And Festivals",
    NumberOfDaysOfAbsenceDueToPersonalLeave:
      "Number Of Days Of Absence Due To Personal Leave",
    contingentPayment: "Contingent Payment (RMB)",
    contingentPayment1: "Contingent Payment",
    contingencyDeduction: "Contingency Deduction",
    PerformanceBonusQuota: "Performance Bonus Quota",
    PerformanceBonusAndOthers: "Performance Bonus And Others",
    Date: "Date",
    PerformanceBonusDistributionRatio: "Performance Bonus Distribution Ratio",
    ActualAttendance: "Actual Attendance",
    ExtraHoursOnWorkingDays: "Extra Hours On Working Days",
    AddPointsDuringHolidays: "Add Points During Holidays",
    startDate: "Start Date",
    startDate1: "Start Date",
    endDate: "End Date",
    ContractUnitName: "Contract Unit Name",
    ApplyUnitName: "Apply Unit Name",
    AmouttoSINOPEC: "Amoutto SINOPEC",
    AmouttoNonSINOPEC: "Amoutto Non SINOPEC",
    WorkingPlace: "Working Place",
    AarrivalDateatKSA: "Aarrival Dateat KSA",
    WorkingDuration: "Working Duration",
    refundQduantity: "Refund Qduantity",
    refundAmount: "Refund Amount",
    RefundReason: "Refund Reason",
    VariableQuantity: "Variable Quantity",
    NameOfAuthorizedAgent: "Name Of Authorized Agent",
    PlannedQuantity: "Planned Quantity",
    PurchaseQuantity: "Purchase Quantity",
    authorizedQuantity: "Authorized Quantity",
    UsageQuantity: "Usage Quantity",
    CancelQuantity: "Cancel Quantity",
    AuthorizedQuantityForUse: "Authorized Quantity For Use",
    AuthorizedQuantity: "Authorized Quantity",
    DateOfBirth: "Date Of Birth",
    ApproveDate: "Approve Date",
    BusinessRequirementDuration: "Business Requirement Duration",
    IssueDate: "Issue Date",
    IssueDate1: "Issue Date",
    PlaceOfIssue: "Place Of Issue",
    CompanyNameInEnglish: "Company Name In English",
    CompanyCRNO: "Company CR NO",
    WorkAbroad: "Work Abroad",
    VisitCountries: "Visit Countries(Area)",
    InvitationUnit: "Invitation Unit",
    VisitDate: "Visit Date",
    WorkBasisAndDescription: "Work Basis And Description",
    ApplicationTime: "Application Time",
    VisitDays: "Visit Days",
    DeparatureFlight: "Deparature Flight",
    ArrivalFlight: "Arrival Flight",
    CurrentStatus: "Current Status",
    CompletionTime: "Completion Time",
    expirationTime: "Expiration Time",
    AirTicket: "Air Ticket",
    VisaInformation: "Visa Information",
    VisaPeriod: "Visa Period",
    VisaPeriod1: "Visa Period",
    AirTicketInformation: "Air Ticket Information",
    DepartureTicketTime: "Departure Ticket Time",
    ReturnTicketTime: "Return Ticket Time",
    VisaAnnex: "Visa Annex",
    Age: "Age",
    ReligionName: "Religion Name",
    Cost: "Cost",
    InsuranceStartTime: "Insurance Start Time",
    InsuranceEndTime: "Insurance End Time",
    BasicSalary: "Basic Salary",
    HousingAllowance: "Housing Allowance",
    CareerLevel: "Career Level",
    CareerName: "Career Name",
    JobOccupationOnIQAMA: "Job Occupation On IQAMA",
    IQAMAJobTitleAR: "IQAMA Job Title AR",
    IQAMAJobTitleCode: "IQAMA Job Title Code",
    socialInsuranceStatus: "social Insurance Status",
    ExecutionType: "Execution Type",
    InjuryTime: "Injury Time",
    StopWorkingTime: "Stop Working Time",
    Injurylocation: "Injury location",
    HospitalName: "Hospital Name",
    DescriptionofClaimResult: "Descriptionof Claim Result",
    AttachmentAddress: "Attachment Address",
    FeeofGovernment: "Feeof Government",
    GovenmentEbankPay: "Govenment Ebank Pay",
    GovenmentEbankPay2: "Govenment Ebank Pay 2",
    SADADTransferPay: "SADAD Transfer Pay",
    SADADTransferPay2: "SADAD Transfer Pay ",
    TotalOnlinePay: "Total Online Pay",
    TotalOnlinePay1: "Total Online Pay (SAR)",
    OtherCost: "Other Cost",
    CosatAllocationtoApplicant: "Cosat Allocationto Applicant",
    DifferenceAmount: "Difference Amount",
    SummaryDate: "Summary Date",
    Currency: "Currency",
    AmountInFigure: "Amount In Figure",
    MethodOfPayment: "Method Of Payment",
    CompletedDate: "Completed Date",
    ServiceAgreementSN: "Service Agreement S/N",
    RegistrationDate: "Registration Date",
    ContractValidity: "Contract Validity",
    AgreementStatus: "Agreement Status",
    MDMSystemSN: "MDM System S/N",
    ICMSSystemSN: "ICMS SystemSN",
    AgreementValue: "Agreement Value",
    CRValidDate: "CR Valid Date",
    VATNO: "VAT NO",
    POBoxOfficeAddress: "PO Box Office Address",
    AccountName: "Account Name",
    BankAddress: "Bank Address",
    ContactName: "Contact Name",
    Recommendby: "Recommendby",
    OutbDate: "Outb Date",
    RetFrom: "Ret From",
    DepartureDateFromEmpCtry: "Departure Date From Emp Ctry",
    ArrivalDateAtEmpCtry: "Arrival Date At Emp Ctry",
    TicketReference: "Ticket Reference",
    OutbFrom: "Outb From",
    OutbTo: "Outb To",
    RetFrom: "Ret From",
    RetTo: "Ret To",
    AirlineCode: "Airline Code",
    TicketIssueDate: "Ticket Issue Date",
    ticketStatus: "Ticket Status",
    DropoffProj: "Drop-off Proj",
    DropoffSubProj: "Drop-off Sub-Proj",
    DropoffUnit: "Drop-off Unit",
    DropoffDate: "Drop-off Date",
    FlightNumber: "Flight Number",
    PickupProj: "PickupProj",
    PickupSubProj: "Pickup Sub Proj",
    PickupUnit: "Pickup Unit",
    PickupDate: "Pickup Date",
    ticketCost: "Ticket Cost(RMB)",
    ticketCost1: "Ticket Cost",
    TicketFareWithoutVATSR: "Ticket Fare Without VAT SR",
    TicketFareWithoutVAT1: "Ticket Fare Without VAT",
    TicketFareVATSR: "Ticket Fare VAT SR",
    TicketFareVATSR1: "Ticket Fare VAT",
    DividingAmount: "Dividing Amount",
    PaymentDate: "Payment Date",
    PaymentStatus: "Payment Status",
    VATAmount: "VAT Amount",
    AmountOfAllocation: "Amount Of Allocation",
    IncomeAmount: "Income Amount",
    CostCategory: "Cost Category",
    SubCostCategoryName: "Sub Cost Category Name",
    CRNumberofBeneficiary: "CR Number of Beneficiary",
    CurrencyName: "Currency Name",
    AmountinWord: "Amountin Word",
    QtySum: "Qty Sum",
    AmountSum: "Amoun tSum",
    Duration: "Duration",
    AirTicketRoute: "AirTicket Route",
    AmountofIssued: "Amount Of Issued",
    AmountofRescheduled: "Amount Of Rescheduled",
    PercentageofRescheduled: "Percentage of Rescheduled",
    InvoiceofRescheduled: "Invoice of Rescheduled",
    PercentageofChangeFee: "Percentage of ChangeFee",
    Urgent: "Urgent",
    PercentageofUrgent: "Percentage of Urgent",
    InvoiceofIssued: "Invoice of Issued",
    Under20Days: "Under 20 Days",
    PercentageofUnder20Days: "Percentage of Under 20 Days",
    Under10Days: "Under 10 Days",
    PercentageofUnder10Days: "Percentage of Under 10 Days",
    OutSafeTrain: "Training status",
    OutSafeTrainStartTime: "Out Safe Train Start Time",
    OutSafeTrainEndTime: "Out Safe Train End Time",
    Place: "Place",
    Timetable: "Timetable",
    CertificateNumber: "Certificate Number",
    ScheduleDate: "Schedule Date",
    InsuranceStatus: "Insurance Status",
    InsuranceCoverageStartsOn: "Insurance Coverage Starts On",
    InsuranceCoverageEndDate: "Insurance Coverage End Date",
    ActionTypeName: "Action Type Name",
    PolicyNumber: "Policy Number",
    InsuranceCompany: "Insurance Company",
    ChannelTypeName: "Channel Type Name",
    PlaceOfAccidentL: "Place Of AccidentL",
    AccidentLType: "AccidentL Type",
    AccidentLTime: "AccidentL Time",
    ClaimStatus: "Claim Status",
    ClaimAmount: "Claim Amount",
    ClaimSettlementResult: "Claim Settlement Result",
    PhysicalExaminationCategory: "Physical Examination Category",
    PhysicalExaminationValueCategory: "Physical Examination Value Category",
    Minimum: "Minimum",
    Maximum: "Maximum",
    PhysicalExaminationTime: "Physical Examination Time",
    Height: "Height",
    Weight: "Weight",
    WaistCircumference: "Waist Circumference",
    BloodOxygen: "Blood Oxygen",
    HeartRate: "Heart Rate",
    BloodPressure: "Blood Pressure",
    BloodDiastolicPressure: "Blood Diastolic Pressure",
    BloodSystolicPressure: " Blood Systolic Pressure",
    BloodGlucose: "Blood Glucose",
    Fasting: "Fasting",
    AfterMeal: "AfterMeal",
    BloodLipids: "Blood Lipids",
    TotalCholesterol: "Total Cholesterol",
    Triglyceride: "Triglyceride",
    HighDensityLipoproteinCholesterol: "High-density Lipoprotein Cholesterol",
    LowDensityLipoproteinCholesterol: "Low-density Lipoprotein Cholesterol",
    EmploymentNature: "Employment Nature",
    SentToCountryRegion: "Sent to country (region)",
    SentToOverseasInstitutionsProjects:
      "Sent to overseas institutions/projects",
    BillNo: "Bill No",
    BillDate: "Bill Date",
    SNEMECProjectSNEMEC: "SNEMEC/Project:SNEMEC",
    UnitDepartment: "Unit/Department",
    AuxiliaryMaterial: "Auxiliary Material",
    SafetyMaterial: "Safety Material",
    OfficeMaterial: "Office Material",
    RequestPeriod: "Request Period",
    MaterialType: "Material Type",
    WhetherToTransfer: "Whether To Transfer",
    Uniform: "Uniform",
    UniformFRC: "Uniform FRC",
    SafetyShoes: "Safety Shoes",
    SafetyHelmet: "Safety Helmet",
    Others: "Others",
    OthersQty: "Others Qty",
    CostSubCategory: "Cost Sub Category",
    DescriptionsOfCost: "Descriptions Of Cost",
    ShortProjectName: "Short Project Name",
    Qties: "Qties",
    ActualCost: "Actual Cost",
    DifferenceProfits: "Difference Profits",
    unitProject: "Unit/Project",
    StatisticalPeriod: "Statistical Period",
    AverageNumberOfPeopl1: "Average number of people (self-owned)",
    AverageNumberOfPeopl2:
      "Average number of people (domestic and international outsourcing)",
    AverageNumberOfPeopl3: "Average number of people (outsourced locally)",
    SalaryOfChineseContractEmployees: "Salary Of Chinese Contract Employees",
    SalaryOfDirectlyEmployedChineseStaff:
      "Salary Of Directly Employed Chinese Staff",
    SalaryOfSaudiEmployees: "Salary Of Saudi Employees",
    SalaryOfEmployeesWithThirdNationality:
      "Salary Of Employees With Third Nationality",
    DomesticInsuranceAndAdditionalBenefitsForChineseContractEmployees:
      "Domestic Insurance And Additional Benefits For Chinese Contract Employees",
    ServicePeriodEndAward: "Service Period EndAward",
    OtherLaborCosts: "Other labor costs (inspection/labor protection)",
    LaborCost: "Labor Cost",
    CostOfOutsourcedPersonnelForChinesePositions:
      "Cost Of Outsourced Personnel For Chinese Positions",
    LocalJobOutsourcingCost: "Local Job Outsourcing Cost",
    PositionOutsourcingFee: "Position Outsourcing Fee",
    OverseasSubsidyDesignBonus: "Overseas subsidy/design bonus",
    SaudiCosts: "Saudi Costs",
    ForeignAffairsCosts: "Foreign Affairs Costs",
    PublicSafetyCosts: "Public Safety Costs",
    IsolationCost: "Isolation Cost",
    SubcontractingCost: "Subcontracting Cost",
    SubcontractingIncome: "Subcontracting Income",
    TotalCost: "Total Cost",
    ServicePeriodEndAward: "Service period end award (withholding)",
    SaudiIncome: "Saudi Income (rebate/reward)",
    ForeignAffairsIncome: "Foreign affairs income (management fee accrual)",
    TicketRevenue: "Ticket Revenue(management fee accrual)",
    LaborIncome: "Labor income (borrowing fee or management fee)",
    OtherIncome: "Other Income",
    TotalRevenue: "Total Revenue",
    NameOfCostAnalysisIndicator: "Name Of Cost Analysis Indicator",
    AnalyticalMetrics: "Analytical Metrics",
    ProfessionOnIQAMA: "Profession On IQAMA",
    WhetherToPrintTheOccupationCategory:
      "Whether To Print The Occupation Category",
    IsThePositionPrinted: "Is The Position Printed",
    TotalSalary: "Total Salary",
    DateOfDeparture1: "Date Of Departure",
    RemittanceMustBeAccompaniedByANoteSpecifying:
      "Remittance Must Be Accompanied By A Note Specifying",
    Modifier: "Modifier",
    modificationTime: "Modification Time",
    OperationCategory: "Operation Category",
    MessageContent: "Message Content",
    ClientIP: "Client IP",
    BrowserType: "Browser Type",
    OperationDate: "Operation Date",
    LogCategory: "Log Category",
    OperatingSystem: "Operating System",
    BrowserVersion: "Browser Version",
    specificDescription: "Specific Description",
    ModuleID: "Module ID",
    DuringTheLogPeriod: "During The Log Period",
    ItemDescription: "Item Description",
    EPIProjectCode: "EPI Project Code",
    ResponsibleUnit: "Responsible Unit",
    ProjectLocation: "Project Location",
    PlannedCompletionDate: "Planned Completion Date",
    ProjectTypeCashIn: "Project type - cash-in",
    InitialLevelRedemption: "Initial Level Redemption",
    OwnersName: "Owner's Name",
    PartyA: "Party A",
    IsItIndependentAndOpenToTheOutsideWorld:
      "Is It Independent And Open To The Outside World",
    IsItAnEmergingBusiness: "Is It An Emerging Business",
    IsItAnEmergingMarket: "Is It An Emerging Market",
    IsItAConsortiumProject: "Is It A Consortium Project",
    ProjectContractAmount: "Project contract (settlement) amount",
    NetOutputValueOfTheProject:
      "Net output value of the project (excluding design)",
    SuperiorProjectDepartment: "Superior Project Department",
    ProjectDescription: "Project Description",
    NatureOfBusiness: "Nature Of Business",
    SuperiorUnit: "Superior Unit",
    SuperiorDepartment: "Superior Department",
    UploadTheManual: "Upload The Manual",
    OrganizationType: "Organization Type",
    Organization: "Organization",
    SuperiorOrganization: "Superior Organization",
    Description: "Description",
    ProjectDepartment: "Project Department",
    AffiliatedInstitution: "Affiliated Institution",
    AffiliatedDepartment: "Affiliated Department",
    RecruitmentProgress: "Recruitment Progress",
    RecruitmentStatus: "Recruitment Status",
    TemplateFile: "Template File",
    UploadAttachment: "Upload Attachment",
    ApprovalForm: "Approval Form",
    AttendanceMonth: "Attendance Month",
    WorkingDays: "Working Days",
    AverageDailyWorkingHours: "Average Daily Working Hours",
    numberOfUsers: "Number Of Users",
    Qualification: "Qualification",
    DynamicAdjustmentOfDaysInTheVacationCycle:
      "Dynamic Adjustment Of Days In The Vacation Cycle",
    ReasonForApplication: "Reason ForApplication",
    TypeOfItinerary: "Type Of Itinerary",
    Category: "Category",
    Quantity: "Quantity",
    UsageReturnDate: "Usage/return date",
    AvailableQuantity: "Available Quantity",
    Validity: "Validity",
    Attachment: "Attachment",
    lengthOfStay: "length Of Stay",
    AutomaticExtraction: "Automatic Extraction",
    VisaUpload: "Visa Upload",
    CancelWarning: "Cancel Warning",
    OverseasPublicSecurityTraining: "Overseas Public Security Training",
    EmployeeHealthAssessment: "Employee Health Assessment",
    ApprovalOfExternalAssignmentSystem:
      "Approval Of External Assignment System",
    ApprovalDocumentForOverseasMission:
      "Approval Document For Overseas Mission",
    VisaApprovalForm: "VisaApproval Form",
    InternationalCertificateOfVaccination:
      "International Certificate Of Vaccination",
    PhysicalExaminationStatus: "Physical Examination Status",
    NoCriminalDoubleAuthentication: "No Criminal Double Authentication",
    CompletionTimeOfMaterialCollection:
      "Completion Time Of Material Collection",
    VisaProcessingCompletionTime: "Visa Processing Completion Time",
    BusinessStatus: "Business Status",
    VisitTimeAndDurationOfStay:
      "Visit time and duration (including travel time)",
    ApplicationDateOfApprovalDocumentForOverseasMission:
      "Application Date Of Approval Document For OverseasMission",
    ApplicationStatus: "Application Status",

    PhotocopyOfPassport: "Photocopy Of Passport",
    PhotocopyOfIQAMA: "Photocopy Of IQAMA",
    bankStatement: "Bank Statement",
    digitalPhoto: "Digital Photo",
    hardCopyPhoto: "Hard Copy Photo",
    OtherMaterials1: "Other Materials 1",
    OtherMaterials2: "Other Materials 2",
    OtherMaterials3: "Other Materials 3",
    SubmissionTimeOfVisaMaterials: "Submission Time Of Visa Materials",
    EmbassyInterviewTime: "Embassy Inter view Time",
    VisaCompletionTime: "Visa Completion Time",
    VisaNumber: "Visa Number",
    WhetherToUse: "Whether To Use",
    DepartureTime: "Departure Time",
    ReturnTime: "Return Time",
    Reason: "Reason",
    ProposedAdjustmentLevel: "Proposed Adjustment Level",
    healthInsuranceCompany: "Health Insurance Company",
    MedicalInsuranceCost: "Medical Insurance Cost",
    surrenderCharge: "Surrender Charge",
    NumberOfFamilyMembers: "Number Of Family Members",
    NumberOfWives: "Number Of Wives",
    NumberOfChildren: "Number Of Children",
    transportationAllowance: "Transportation Allowance",
    GOSIStandardForeign: "GOSI Standard Foreign",
    GOSIDeductionCoefficient: "GOSI Deduction Coefficient",
    OtherIncome: "Other Income",
    Custodian: "Custodian",
    lendTime: "Lend Time",
    returnTime: "Return Time",
    CertificateCustodianUnit: "Certificate Custodian Unit",
    IdNumber: "Id Number",
    HandoverDate: "Handover Date",
    Recipient: "Recipient",
    Deliverer: "Deliverer",
    Recipient2: "Recipient 2",
    Deliverer2: "Deliverer 2",
    InStock: "In Stock",
    ReturnDate: "Return Date",
    DoYouWantToPurchaseSOSService: "Do You Want To Purchase SOS Service",
    ParentExpenseItem: "Parent Expense Item",
    paymentMonth: "Payment Month",
    paymentYear: "Payment Year",
    SendTime: "Send Time",
    WhetherToview: "Whether To view",
    Urgent1: "Urgent",
    RegularType: "Regular Type",
    Total: "Total",
    Month: "Month",
    projectUnit: "Project Unit",
    IssueNewIqama: "Issue New Iqama",
    RenewIqama: "Renew Iqama",
    SingleExitReentryVisa: "Single Exit Reentry Visa",
    MultipleExitReentryVisa: "Multiple Exit Reentry Visa",
    ExtendExitReentryVisa: "Extend Exit Reentry Visa",
    IssueBusniessVisitVisa: "Issue Busniess Visit Visa",
    BusniessVisitVisaExtension: "Busniess Visit Visa Extension",
    IssueWorkingVisitVisa: "Issue Working Visit Visa",
    WrokingVisitVisaExtension: "Wroking Visit Visa Extension",
    IssueTemporaryWorkingVisa: "Issue Temporary Working Visa",
    TemporaryWrokingVisaExtension: "Temporary Wroking Visa Extension",
    TransferOfSponsorship: "Transfer Of Sponsorship",
    IssueVisitNonWorkingCountry: "Issue Visit Non Working Country",
    UpdatePassport: "Update Passport",
    CancelIQAMA: "Cancel IQAMA",
    IssueExitVisa: "Issue ExitVisa",
    CcancelExitVisa: "Ccancel ExitVisa",
    ChangeIQAMAProfessionIQAMA: "Change IQAMA Profession IQAMA",
    CancelExitReentry: "Cancel Exit Reentry",
    IssueNewDrivingLicense: "Issue New Driving License",
    RenewDrivingLicense: "Renew Driving License",
    OtherPayment: "Other Payment",
    EvaluationDate: "Evaluation Date",
    AssessmentResults: "Assessment Results",
    SupplierAbbreviationName: "Supplier Abbreviation Name",
    ContractRenewalTimes: "Contract Renewal Times",
    ValidDateOfRenwalAagreement: "ValidDate Of Renwal Aagreement",
    ConversationDate: "Conversation Date",
    ReasonForConversation: "Reason For Conversation",
    ResultRecord: "Result Record",
    FileName: "File Name",
    CheckDate: "Check Date",
    CheckUnit: "Check Unit",
    CheckDetails: "Check Details",
    CheckResult: "Check Result",
    MedicalMeasures: "Medical Measures",
    CertificateNO: "Certificate NO",
    TraadeName: "Traade Name",
    NOOfEstablishment: "NO Of Establishment",
    IssuanceGovSystem: "Issuance GovSystem",
    QualificationsCertificates: "Qualifications & Certificates",
    DateOfIssueHijri: "Date of Issue (Hijri)",
    ValidDateHijri: "Valid Date (Hijri)",
    FixedOvertimeWage: "Fixed Overtime Wage",
    nation: "Nation",
    PlaceOfOrigin: "Place Of Origin",
    City: "City",
    PersonnelLocation: "Personnel Location",
    Address: "Address",
    domesticPhone: "Domestic Phone",
    localPhone: "Local Phone",
    personalEmail: "Personal Email",
    WorkEmail: "Work Email",
    MaritalStatus: "Marital Status",
    HighestEducation: "Highest Education",
    HighestDegree: "Highest Degree",
    HighEduTime: "HighEdu Time",
    JoinWorkTime: "Join Work Time",
    Specialities: "Specialities",
    Politics: "Politics",
    EmergencyContact: "Emergency Contact",
    RelationshipWithMyself: "Relationship With Myself",
    EmergencyContactPhone: "Emergency Contact Phone",
    Language1: "Language",
    LanguageLevel1: "Language Level",
    ForeignAffairsInformation: "Foreign Affairs Information",
    ContactInformation: "Contact Information",
    RelatedTags: "Related Tags",
    BasicInformation: "Basic Information",
    QQ: "QQ",
    UserID: "User ID",
    Company: "Company",
    PositionNature: "Position Nature",
    PositionHierarchy: "Position Hierarchy",
    PositionName2022: "Position Name 2022",
    CostAccumulations: "Cost Accumulations",
    ContractUnit: "Contract Unit",
    Employer: "Employer",
    JoinUnitTime: "Join Unit Time",
    LastestInKsaDate: "Lastest In Ksa Date",
    FirstTimeInKsa: "First Time In Ksa",
    LastestInUaeDate: "Lastest In Uae Date",
    FirstTimeInUae: "First Time In Uae",
    ProfessionalQualification: "Professional Qualification",
    QualificationDate: "Qualification Date",
    SkillLevel: "Skill Level",
    SkillCertDate: "Skill Cert Date",
    CertificateName: "Certificate Name",
    ExpiryDate: "Expiry Date",
    CertificateType: "Certificate Type",
    Guarantor: "Guarantor",
    EntryVisaType: "Entry Visa Type",
    OverseasWorkExperience: "Overseas Work Experience",
    LatestDemobilizationInformation: "Latest Demobilization Information",
    AccountNameCHS: "Account Name CHS",
    AccountNameEN: "Account Name EN",
    ACCOUNTNo: "ACCOUNT No",
    IBANNo: "IBAN No",
    LocalBankName: "Local Bank Name",
    RegisterPhone: "Register Phone",
    RegisterSalary: "Register Salary",
    EffectiveDate: "Effective Date",
    AttendanceMode: "Attendance Mode",
    UniformSize: "Uniform Size",
    PantsSize: "Pants Size",
    ShoeSize: "Shoe Size",

    BloodType: "Blood Type",
    VaccinationStatus: "Vaccination Status",
    CurrentDiseases: "Current Diseases",
    Medications: "Medications",
    DrugAllergies: "Drug Allergies",
    PastMedicalHistory: "Past Medical History",
    FamilyMedicalHistory: "Family Medical History",
    issuingAuthorityName: "Issuing Authority Name",
    EmploymentHistory: "Employment History",
    JobSequence: "Job Sequence",
    JobTitle: "Job Title",
    SigningUnitOfEmploymentAgreement: "Signing Unit Of Employment Agreement",
    ProhibitedList: "Prohibited List",
    JoinUnitTime: "Join Unit Time",
    DepartureDateOverseas: "Departure Date Overseas",
    LastestInKsaDate: "Lastest In Ksa Date",
    FirstTimeInKsa: "First Time In Ksa",
    LastestOutKsaDate: "Lastest Out Ksa Date",
    LastestInUaeDate: "Lastest In Uae Date",
    FirstTimeInUae: "First Time In Uae",
    LastestOutUaeDate: "Lastest Out Uae Date",
    ProfessionalTitlesName: "Professional Titles Name",
    GetTime: "Get Time",
    VocationalSkillLevelName: "Vocational Skill Level Name",
    DateofSkill: "Date of Skill",
    IssuedDate: "Issued Date",
    ExpiryDate1: "Expiry Date",
    PerformanceReviewCycle: "Performance Review Cycle",
    ExaminationResult: "Examination Result",
    AccountNameCHS1: "Account Name CHS",
    AccountNameEN1: "Account Name EN",
    ACCOUNNo: "ACCOUN No",
    IBANNo: "IBAN No",
    BankName1: "Bank Name",
    BankCode1: "Bank Code",
    RegisterPhone1: "Register Phone",
    RegisterSalary1: "Register Salary",
    BaseSalary: "Base Salary",
    RetainSalary: "Retain salary",
    HousingSubsidyStandards: "Housing Subsidy Standards",
    OtherDomesticSubsidies: "Other Domestic Subsidies",
    MinimumWageStandardForEnterprisesInNanjingMonthly:
      "Minimum wage standard for enterprises in Nanjing (monthly)",
    HighTechSkillsAllowance: "High tech (skills) allowance",
    rentSubsidies: "Rent Subsidies",
    OvertimeDailyWage: "Overtime Daily Wage",
    AddSomeStandards: "Add Some Standards",
    OverseasWorkAllowance: "Overseas Work Allowance",
    TeamLeaderAllowance: "Team Leader Allowance",
    HardshipAllowanceCoefficient: "Hardship Allowance Coefficient",
    HardshipSubsidyBase: "Hardship Subsidy Base",
    PerformanceBonusProportionalStandard:
      "Performance bonus - proportional standard",
    PerformanceBonusFixedUnitPrice: "Performance bonus - fixed unit price",
    JobSubsidyStandard: "Job Subsidy Standard",
    RegionalSubsidyStandards: "Regional Subsidy Standards",
    SubsidyStandardsForFieldWork: "Subsidy Standards For Field Work",
    InsuranceAllowance: "Insurance Allowance",
    HolidayOvertimePayStandard: "Holiday Overtime Pay Standard",
    StandardForHolidayOvertimePay: "Standard For Holiday Overtime Pay",
    BasicSalaryGOSIRegistration: "Basic salary - GOSI registration",
    HousingSubsidyRegistration: "Housing Subsidy - Registration",
    BasicSalaryStandardForeignNationals:
      "Basic salary standard - foreign nationals",
    AccommodationAndMealSubsidyStandardsForeignNationals:
      "Accommodation and meal subsidy standards - foreign nationals",
    TransportationSubsidyStandardsForeignNationals:
      "Transportation Subsidy Standards - Foreign Nationals",
    MedicalSubsidyStandardsForeignNationals:
      "Medical subsidy standards - foreign nationals",
    WorkExperienceSubsidyStandardsForeignNationals:
      "Work Experience Subsidy Standards - Foreign Nationals",
    PerformanceBonusStandardsForeignNationals:
      "Performance Bonus Standards - Foreign Nationals",
    TwoHourSubsidyForeignNationals: "Two hour subsidy - foreign nationals",
    GOSIStandardForeignNationals: "GOSI Standard - Foreign Nationals",
    GOSIDeductionCoefficient: "GOSI deduction coefficient",
    OutSafeTrainStatus: "Out Safe Train Status",
    OutSafeTrainValidity: "Out Safe Train Validity",
    JoinInsuranceStatus: "Join Insurance Status",
    JoinInsuranceEndTime: "Join Insurance End Time",
    MedicalInsuranceStatus: "Medical Insurance Status",
    MedicalInsuranceEndTime: "Medical Insurance End Time",
    MedicalInsuranceClassLevel: "Medical Insurance Class Level",
    SocialInsuranceStatus: "Social Insurance Status",
    SocialInsuranceEndTime: "Social Insurance End Time",
    SocialInsuranceClassLevel: "Social Insurance Class Level",
    OverseasWorkExperience: "Overseas Work Experience",
    LatestDemobilizationInformation: "Latest Demobilization Information",
    EventType: "Event Type",
    ChangeDate: "Change Date",
    GoAbroadDate: "Go Abroad Date",
    AdjustDate: "Adjust Date",
    EmployeeInfoType: "Employee Info Type",
    EmployeeInfoSubType: "Employee Info Sub Type",
    OldValue: "Old Value",
    NewValue: "New Value",
    BackupDate: "Backup Date",
    CostAggregation: "Cost Aggregation",
    CostCategory1: "Cost Category",
    CostSubCategory1: "Cost Sub Category",
    CostCategoryDetail: "Cost Category Detail",
    ImportBasicInformation: "Import Basic Information",
    ImportWorkInformation: "Import Work Information",
    Year: "Year",
    week: "Week Number",
    Type: "Type",
    SNEILocalLaborServices: "SNEI / Local Labor Services",
    DomesticLocalLaborServices: "Domestic / Local Labor Services",
    LocalSubcontractingChineseEmployee:
      "Local Subcontracting / Chinese Employee",
    LocalSubcontractingThirdStateEmployee:
      "Local Subcontracting / Third State Employee",
    LocalSubcontractingLocalEmployees: "Local Subcontracting / Local Employees",
    InternalIn: "Internal In",
    InternalOut: "Internal Out",
    ExternalIn: "External In",
    ExternalOut: "External Out",
    InternalInRemarks: "Internal In Remarks",
    ExternalInRemarks: "External In Remarks",

    LocalLaborServices: "Local LaborServices",
    DomesticSubcontracting: "Domestic Subcontracting",
    LocalSubcontracting: "Local Subcontracting",
    NumberOfnonSinopecvisaholders: "(Number of non Sinopec visa holders)",
    ChineseEmployee: "Chinese Employee",
    ThirdStateEmployee: "ThirdState Employee",
    LocalEmployees: "Local Employees",
    RouteType: "Route Type",
    ProductTime: "Product Time",
    AdjustedYears: "Adjusted Years",
    CumulativeYears: "Cumulative Years",
    whetherHotspot: "Whether Hotspot",
    whetherPinToTop: "Whether Pin To Top",
    MessageDetails: "Message Details",
    GovernmentPlatform: "Government Platform",
    Registrant: "Registrant",
    AuthorizationDepartment: "Authorization Department",
    AnnualFeeofGovSystem: "Annual Fee of GovSystem",
    RegisteredEmail: "Registered Email",
    LoginOTPMobileNO: "Login OTP Mobile NO",
    WebsiteAddress: "Website Address",
    DescriptionofFunction: "Descriptionof Function",
    LoginPassword: "Login Password",
    WorkInformation: "Work Information",
    QualificationAbility: "Qualification Ability",
    BankAccount: "Bank Account",
    SalaryStandard: "Salary Standard",
    StaffPhoto: "Staff Photo",
    dateRecordedStatus: "Date Recorded Status",
    DepartureDateOverseas: "Departure Date Overseas",
    CyclicYear: "Cyclic Year",
    CountryStatyDurationTimes: "Country/ Staty Duration/Times",
    PreviousSponsorVisaTypeDemobilizationDate:
      "Previous Sponsor/Visa Type/ Demobilization Date",
    DrugContraindications: "Drug Contraindications",
    Pulse: "Pulse(time/minute)",
    OrganExamination: "Organ Examination",
    PhysicalCharacteristics: "Physical Characteristics",
    NervousSystem: "Nervous System",
    LaboratoryTests: "Laboratory Tests",
    Vaccination: "Vaccination",
    MedicationStatus: "Medication Status",
    PastMedicalHistory: "Past Medical History",
    DiseaseList: "Disease List",
    Hypertension: "Hypertension",
    Hyperlipidemia: "Hyperlipidemia",
    Hyperglycemia: "Hyperglycemia",
    HeartDisease: "Heart Disease",
    Diabetes: "Diabetes",
    Bronchitis: "Bronchitis",
    GastrointestinalDisease: "Gastrointestinal Disease",
    othersymptom: "Other（Symptom：",
    Indicator: "Indicator",
    FamilyMedicalHistoryList: "Family Medical HistoryList",
    CoronaryHeartDisease: "Coronary Heart Disease",
    CerebrovascularDisease: "Cerebrovascular Disease",
    MalignantTumor: "Malignant Tumor",
    otherJB: "Other",
    Father: "Father",
    Mother: "Mother",
    MaterialName: "Material Name",
    UnitJL: "Unit",
    DeliveryTime: "Delivery Time",
    ModelSpecification: "Model/Specification",
    Percentage: "Percentage",
    OvertimeDate: "Overtime Date",
    DescriptionOfOvertimeWork: "Description Of Overtime Work",
    EmployeeTypeName: "Employee Type Name",
    EmployeeCategoryName: "Employee Category Name",
    DateofDeparture: "Date of Departure",
    ReturnDate: "Return Date",
    VisaNature: "Visa Nature",

    SettlementType: "Settlement Type",
    JobProfession: "Job Profession",
    Qualif: "Qualif",
    QtyJG: "Qty",
    Rate: "Rate",
    FATBearedBy: "FAT Beared By",
    RateofOverheadFee: "Rate of Overhead Fee",
    CertificateLevel: "Certificate Level",
    DateOfIssueQZ: "Date Of Issue",
    NameOfManpowerSupplier: "Name Of Manpower Supplier",
    DateOfVerification: "Date Of Verification",
    ResultOfverification: "Result Of verification",
    ItemsofVerification: "Items of Verification",
    CourseContent: "Course Content",
      LastUpdateTime: "Last Update Time",
  },

  //短名词
  shortNoun: {
    OrganizationalStructureChart: "Organizational Structure Chart",
    create: "Create",
    query: "Query",
    export: "Export",
    import: "Import",
    FirstImport: "First Import",
    transfer: "Transfer",
    FeeUpdate: "Fee Update",
    Update: "Update",
    costConfirmation: "Cost Confirmation",
    costSummary: "Cost Summary",
    addOtherPayments: "Other Payments",
    approvalFormAddition: "Approval Form Addition",
    maintenanceEntity: "Maintenance Entity",
    statistics: "Statistics",
    batchSetSuperior: "Batch SetSuperior",
    batchRelease: "Batch Release",
    displayChart: "Display Chart",
    usageHistory: "Usage History",
    bonusPage: "Bonus Page",
    domesticDistribution: "Domestic Distribution",
    homePage: "Home Page",
    workbench: "Workbench",
    workPlatform: "Work Platform",
    employeeCenter: "Employee Center",
    managementCenter: "Management Center",
    commonFunctions: "Common Application",
    approvalMatters: "Approval Matters",
    commonTemplate: "Common Template",
    notice: "Notice",
    reference: "Reference",
    flightItinerary: "Flight Itinerary",
    information: "Information",
    logOut: "Log Out",
    management: "Management",
    more: "More",
    hello: "Hello",
    lastLoginTime: "Last Login Time",
    CCItems: "CC Items",
    myMessage: "My Message",
    personalInformation: "Personal Information",
    foreignAffairs: "Foreign Affairs",
    personnelAffairs: "Personnel Affairs",
    myDocuments: "My Documents",
    otherApplications: "Other Applications",
    toDo: "To-do",
    completedTasks: "Completed Tasks",
    returned: "Returned",
    ended: "Finished",
    seeOffInformation: "see Off Information",
    pickUpInformation: "Pick Up Information",
    itemName: "Item Name",
    nodeLocation: "Node Location",
    submissionTime: "Submission Time",
    retentionTime: "Retention Time",
    message: "Message",
    pendingReview: "Pending Review",
    reject: "Reject",
    approved: "Approved",
    select: "Select",
    save: "Save",
    Cancel: "Cancel",
    Close: "Close",
    Release: "Release",
    LoginAccount: "Login Account",
    AccountPassword: "Account Password",
    Code: "Code",
    Login: "Login",
    centre: "",
    MessageTitle: "Message Title",
    MessageType: "Message Type",
    IncreaseStaff: "Increase Staff",
    MessageContent: "Message Content",
    download: "Download",
    product: "Product",
    NotPploaded: "Not Pploaded",
    downloadAttachment: "Download Attachment",
    menuID: "Menu ID",
    menuName: "Menu Name",
    ParentID: "Parent ID",
    serialNumber: "Serial Number",
    moduleCode: "Module Code",
    moduleType: "Module Type",
    HomepageShortcuts: "Homepage Shortcuts",
    PermissionButton: "Permission Button",
    ShortcutIcon: "Shortcut Icon",
    AddChildLevel: "Add Child Level",
    AddSibling: "Add Sibling",
    DeleteMenu: "Delete Menu",
    AttachmentType: "Attachment Type",
    Approval: "Approval",
    Pass: "Pass",
    Refuse: "Refuse",
    Reject: "Reject",
    Account: "Account",
    OldPassword: "Old Password",
    NewPassword: "New Password",
    ConfirmedPassword: "Confirmed Password",
  },

  //提示
  placeholder: {
    input: "Please Enter",
    select: "Please Select",
    date: "Select Date",
    year: "Select Year",
    moon: "Select Moon",
    startDate: "Start Date",
    endDate: "End Date",
    to: "To",
    name: "Please enter the menu name",
    search: "Search",
    langName:
      "Physical characteristics (facial features/skin/sclera/lymph nodes/head/neck/spine and limbs, vision/hearing)",
  },

  //弹框提示词
  prompt: {
    title1: "Successfully created",
    title2: "Edit successful",
    title3: "Deleted successfully",
    title4:
      "This operation will permanently delete the data. Do you want to continue?",
    title5: "Import successful",
    title6: "Saved successfully",
    title7: "Payment successful",
    title8: "Successfully completed",
    title9: "Approval successful",
    title10: "Successfully transferred",
    title11: "Setup successful",
    title12: "Expense confirmation completed",
    title13: "Expense summary completed",
    title14: "Published successfully",
    title15: "Do you want to include ticket purchase",
    title16: "Successfully added to the flight ticket purchase",
    title17:
      "Confirm to submit the current approval form, do you want to continue?",
    title18: "The approval form has been successfully added",
    title19: "The attachment has been successfully uploaded",
    title20: "Connection successful",
    title21: "There is no cost center under this option. Please select again",
    title22: "The expense entity cannot be empty",
    title23: "Not yet developed!",
    title24: "Employee number does not exist",
    title25: "No updates this month!",
    title26: "The departure date must be later than the arrival date",
    title27: "Please upload your resume and qualification certificates",
    title28: "The names of the associated projects are inconsistent",
    title29:
      "The names of the sub-projects to which they belong are inconsistent",
    title30: "The employing units are inconsistent",
    title31:
      "Inconsistent information about the department to which it belongs",
    title32: "The local employer indicated is inconsistent",
    title33:
      "The departure date from the workplace must be earlier than the arrival date at the workplace",
    title34:
      "For work visa application, it is required to upload passport, ID card, and health vaccination certificate",
    title35:
      "If your age is over 60, you need to upload an over-age approval attachment",
    title36: "For the visit visa, a passport attachment is required",
    title37: "The login account cannot be empty",
    title38: "The account password cannot be empty",
    title39: "Verification code cannot be empty",
    title40: "ID can only be entered as pure numbers",
    title41: "Please select foreign relations first",
    title42: "Please select the approval status first",
    title43:
      "The consent status cannot be empty. Please first select whether you agree or not",
    title44:
      "If there are different consent options, the approval status cannot be set to 'passed'",
    title45: "Please select the departure city",
    title46: "Please select the destination city",
    title47: "Please select the route category",
    title48: "Please select at least one row of data",
    title49: "There are confirmed data in the data, please cancel",
    title50:
      "Once the fee is confirmed, it cannot be modified. Are you sure to confirm the fee?",
    title51: "There is summarized data in the data, please cancel",
    title52: "There is unconfirmed expense data in the data. Please cancel",
    title53:
      "When adding an approval form, only one piece of data can be selected!",
    title54: "Please select the process",
    title55: "No more",
    title56: "Please select a task outside your jurisdiction first",
    title57: "The selected data has inconsistent expense periods",
    title58: "The selected data has inconsistent payee information",
    title59: "The selected data contains inconsistencies in local employers",
    title60:
      "The process end node is not supported as the starting point of a connection",
    title61: "Process start is not supported as a connection endpoint",
    title62: "The node does not support connecting to itself",
    title63: "This relationship already exists and cannot be created again",
    title64: "Wiring loop between two nodes is not supported",
    title65:
      "The 'Process Start' node already exists, and only one Process Start node can be selected",
    title66:
      "The 'Process End' node already exists, and only one Process End node can be selected",
    title67: "Please drag the node onto the canvas",
    title68: "The process name cannot be empty",
    title69: "Please select the process instance on the left",
    title70: "Please select at least one process node",
    title71:
      "Only files with extensions of jpg, png, jpeg, pdf, xls, xlsx, rar, and zip can be uploaded!",
    title72: "The start date cannot be earlier than the current date",
    title73: "The start date cannot be greater than or equal to the end date",
    title74: "Only files with extensions of xls or xlsx can be uploaded!",
    title75: "Only files with a .pdf extension can be uploaded!",
    title76:
      "Only files with extensions of jpg, png, jpeg, pdf, xls, and xlsx can be uploaded!",
    title77:
      "Only files with extensions of jpg, png, jpeg, and pdf can be uploaded!",
    title78: "Only files with extensions of jpg, jpeg, or png can be uploaded!",
    title79:
      "Only files with extensions of pnf, docx, png, jpg, and gif can be uploaded!",
    title80: "Please select the role list first",
    title81: "Please select a node",
    title82: "The superior organization cannot be itself",
    title83:
      "The available quantity is less than 0, indicating a data error. Please check the data",
    title84: "Are you sure to delete the selected line?",
    title85: "Are you sure you want to delete the node",
    title86: "This operation is a paid operation. Do you want to continue?",
    title87:
      "This operation is a settlement operation. Do you want to continue?",
    title88:
      "The flight ticket may be selected incorrectly. Are you sure to submit?",
    title89:
      "Please proceed to the collaborative office system for processing?",
    title90:
      "This operation will permanently delete the data (and its sub-items). Do you want to continue?",
    title91:
      "Deleting it will also delete the corresponding payment notice, split sheet, and approval sheet. Are you sure you want to delete it?",
    title92: "The selected data exhibits inconsistency in ticketing agents",
    title93: "Is it necessary to apply for an air ticket",
    title94: "Generated successfully",
    title95:
      "The first phase of information has been entered into the system. Please promptly input the remaining employee details.",
    title96:
      "The pick-up and drop-off station information lacks complete dates and times",
    title97: "Please change your password first!",
  },
};
